import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallingMadeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallingMade",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.83 15.62c.14.39.31.78.51 1.18 1.23 2.5 2.8 4.64 4.67 6.46 1.83 1.87 3.97 3.42 6.33 4.58l.14.06c.72.35 1.57.68 2.45.92l.11.03c2.66.72 5.05.44 6.5-1.02l1.35-1.37c.36-.35.57-.84.57-1.38s-.22-1.03-.57-1.38l-3.67-3.64c-.35-.35-.83-.57-1.37-.57s-1.02.22-1.37.57l-2.66 2.66c-.23.23-.56.38-.91.38s-.68-.14-.91-.38l-5.51-5.46c-.24-.23-.38-.56-.38-.91s.15-.68.38-.91l2.66-2.66c.35-.35.57-.83.57-1.37s-.22-1.02-.57-1.37L7.52 6.36c-.35-.35-.83-.57-1.37-.57s-1.02.22-1.37.57L3.41 7.72c-1.71 1.71-1.8 4.66-.58 7.9M28.18 3.08l-7.24 7.24-2.98-2.98c-.19-.19-.46-.31-.76-.31-.59 0-1.07.48-1.07 1.07 0 .29.12.56.31.76l3.73 3.73a1.09 1.09 0 0 0 1.52 0l7.99-7.99a1.09 1.09 0 0 0 0-1.52 1.09 1.09 0 0 0-1.52 0Z"
    })
  }));
};